import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ParametroService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunCodigoParametro(codigo, callback) {
        const inputParams = {
            entidad: { codigo },
            paginaActual: 1,
            cantidadRegistrosPorPagina: -1
        };
        this.gqlclient.query({
            query: gql `
          query (
            $entidad: parametroInputType
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            parametro {
              obtenerSegunCodigoParametro(
                entidad: $entidad
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                  listParametroSucursal {
                    sucursal_codigo
                    valor
                    rut_empresa
                  }
                  parametroEmpresa {
                    empresa_rut
                    valor
                  }
                  es_empresa
                  es_sucursal
                }
              }  
            }
          }  
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache'
        }, (response) => {
            const { mensajes, respuesta } = response.data.parametro.obtenerSegunCodigoParametro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerParametrosConFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $parametro: String
            $estado: Int
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            parametro {
              obtenerSegunFiltroParametro(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    parametro: $parametro
                    estado: $estado
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    tipo_parametro_codigo
                    nombre
                    descripcion
                    activado
                    tipo_parametro_nombre
                  }
                }
              }
            }  
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache'
        }, (response) => {
            const { mensajes, respuesta } = response.data.parametro.obtenerSegunFiltroParametro;
            callback({ mensajes, respuesta });
        });
    }
    guardarParametroConEmpresaSucursal(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation (
            $entidad: parametroInputType
          ) {
            parametro {
              guardarParametroEmpresaSucursal(
                entidad: $entidad
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache'
        }, (response) => {
            const { mensajes, respuesta } = response.data.parametro.guardarParametroEmpresaSucursal;
            callback({ mensajes, respuesta });
        });
    }
    editarParametroConEmpresaSucursal(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation (
            $entidad: parametroInputType
          ) {
            parametro {
              editarParametroEmpresaSucursal(
                entidad: $entidad
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache'
        }, (response) => {
            const { mensajes, respuesta } = response.data.parametro.editarParametroEmpresaSucursal;
            callback({ mensajes, respuesta });
        });
    }
    cambiarEstadoParametro(codigo, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation (
            $codigo: Decimal
          ) {
            parametro {
              cambiarEstadoParametro(
                codigo: $codigo
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  tipo_parametro_codigo
                  nombre
                  descripcion
                  activado
                  tipo_parametro_nombre
                }
              }
            }
          }
        `,
            variables: { codigo },
            fetchPolicy: 'no-cache'
        }, (response) => {
            const { mensajes, respuesta } = response.data.parametro.cambiarEstadoParametro;
            callback({ mensajes, respuesta });
        });
    }
}
ParametroService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ParametroService_Factory() { return new ParametroService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ParametroService, providedIn: "root" });
